import PropTypes from 'prop-types'
import { Box, HStack, Link, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import UnderlineHeading from '../../../../components/UnderlineText/UnderlineHeading'
import InfoLabel from '../../../EmployeeDetails/components/InfoLabel'
import { useLabels } from '../../../../utils/hooks/useLabels/useLabels'

export const ItemWrapper = ({ children }) => {
  return <Box w="40%">{children}</Box>
}

ItemWrapper.propTypes = {
  children: PropTypes.node,
}
export default function CompanyInfo({ showMore, data = {} }) {
  const { texts } = useLabels()

  const [email, setEmail] = React.useState('')
  const [showEmail, setShowEmail] = React.useState(false)
  const [formattedEmail, setFormattedEmail] = React.useState('')

  React.useEffect(() => {
    if (data?.sEmailCambioClave) {
      setEmail(data.sEmailCambioClave)
      setFormattedEmail(
        `*****${data.sEmailCambioClave?.split('@')[0].slice(-2)}@*****.${
          data.sEmailCambioClave?.split('@')[1].split('.')[1]
        }`,
      )
    }
  }, [data?.sEmailCambioClave])

  return (
    <VStack w="100%" spacing="30px" alignItems="flex-start">
      <Box>
        <UnderlineHeading text="información de la empresa" variant="h5" />
      </Box>
      <HStack
        spacing={0}
        gap="16px"
        justifyContent="flex-start"
        w="100%"
        wrap="wrap"
      >
        <ItemWrapper>
          <InfoLabel title={texts.fantasy_name} value={data?.sNombreFantasia} />
        </ItemWrapper>
        <ItemWrapper>
          <InfoLabel title={texts.turn} value={data?.sGiro} />
        </ItemWrapper>
        <ItemWrapper>
          <InfoLabel title={texts.business_name} value={data?.sRazonSocial} />
        </ItemWrapper>
        <ItemWrapper>
          <InfoLabel title={texts.dni} value={data?.sRut} />
        </ItemWrapper>
        <ItemWrapper>
          <InfoLabel
            title={texts.operational_interlocutor}
            value={data?.sInterlocutorOperativo}
          />
        </ItemWrapper>
        <ItemWrapper>
          <InfoLabel
            title={`${texts.phone} ${texts.operational_interlocutor}`}
            value="Dato"
          />
        </ItemWrapper>
        <ItemWrapper>
          <InfoLabel
            title={texts.partner_email}
            value={data?.sEmailInterlocutor}
          />
        </ItemWrapper>
        <ItemWrapper>
          <InfoLabel
            title={texts.incorporation_date}
            value={data?.sFechaIncorporacion}
          />
        </ItemWrapper>
        <ItemWrapper>
          <InfoLabel title={texts.company_address} value={data?.sDireccion} />
        </ItemWrapper>
        <ItemWrapper>
          <InfoLabel title={texts.holding} value={data?.sNombreHolding} />
        </ItemWrapper>
        {showMore && (
          <>
            <ItemWrapper>
              <InfoLabel
                title={texts.email_change_password}
                value={showEmail ? email : formattedEmail}
              />
            </ItemWrapper>
            <ItemWrapper>
              <div
                style={{
                  height: 55,
                  paddingTop: 17,
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                <Link
                  style={{ color: '#aaa', textDecoration: 'underline' }}
                  onClick={() => {
                    setShowEmail(!showEmail)
                  }}
                >
                  <Text
                    textDecor="underline"
                    cursor="pointer"
                    variant="caption1"
                  >
                    {texts.view_email}
                  </Text>
                </Link>
              </div>
            </ItemWrapper>
          </>
        )}
      </HStack>
    </VStack>
  )
}

CompanyInfo.propTypes = {
  data: PropTypes.any,
  showMore: PropTypes.bool,
}
